<div class="container animated zoomIn fast">
    <div class="row">
        <div class="col">
            <div id="logo">
                <a routerLink="/">
                    <img src="assets/img/logo.svg" draggable="false" alt="Logo">
                </a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="col text-center mb-4">
                        <h5>AbaQus Field · Register new user</h5>
                    </div>
                    <div class="col">
                        <form [formGroup]="registerForm" (ngSubmit)="register()">
                            <div class="row form-group">
                                <label for="username" class="col-4 col-form-label">User ID:</label>
                                <input type="text" id="username" autocomplete="off"
                                       class="form-control col-sm-8" value="{{username}}" readonly/>
                            </div>
                            <div class="row form-group">
                                <label for="email-address" class="col-4 col-form-label">Email address:</label>
                                <input type="text" id="email-address" autocomplete="off"
                                       class="form-control col-sm-8" value="{{email}}" readonly/>
                            </div>
                            <div class="row form-group">
                                <label for="password" class="col-4 col-form-label">Desired password:</label>
                                <input type="password" formControlName="password" id="password" autocomplete="off"
                                       class="form-control col-sm-8" placeholder="insert password"
                                       [ngClass]="{ 'is-invalid': submitted && formCtr.password.errors }"/>
                                @if (submitted && formCtr.password.errors) {
                                    <div class="invalid-feedback offset-4">
                                        @if (formCtr.password.errors.required) {
                                            <div>The desired password is required
                                            </div>
                                        }
                                        @if (formCtr.password.errors.server_error) {
                                            <div>
                                                {{ formCtr.password.errors.server_error }}
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="row form-group">
                                <label for="organization" class="col-4 col-form-label">Organization code:</label>
                                <select id="organization" class="form-control col-sm-8"
                                        formControlName="organization_code"
                                        [ngClass]="{ 'is-invalid': submitted && formCtr.organization_code.errors }">
                                    <option disabled value="">- select organization code -</option>
                                    @for (organization of organizations; track organization) {
                                        <option [value]="organization?.id">
                                            {{ organization?.name }}
                                        </option>
                                    }
                                </select>
                                @if (submitted && formCtr.organization_code.errors) {
                                    <div class="invalid-feedback offset-4">
                                        @if (formCtr.organization_code.errors.required) {
                                            <div>The organization is required</div>
                                        }
                                        @if (formCtr.organization_code.errors.server_error) {
                                            <div>
                                                {{ formCtr.organization_code.errors.server_error }}
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="row form-group">
                                <label for="country" class="col-4 col-form-label">Country:</label>
                                <select id="country" class="form-control col-sm-8" formControlName="country"
                                        [ngClass]="{ 'is-invalid': submitted && formCtr.country.errors }">
                                    <option disabled value="">- select country -</option>
                                    @for (country of countries; track country) {
                                        <option value="{{ country.id }}">
                                            {{ country?.name }}
                                        </option>
                                    }
                                </select>
                                @if (submitted && formCtr.country.errors) {
                                    <div class="invalid-feedback offset-4">
                                        @if (formCtr.country.errors.required) {
                                            <div>The country is required</div>
                                        }
                                        @if (formCtr.country.errors.server_error) {
                                            <div>
                                                {{ formCtr.country.errors.server_error }}
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="row form-group">
                                <label for="date-format" class="col-4 col-form-label">Date format:</label>
                                <select id="date-format" class="col-4 form-control" formControlName="simple_date_format"
                                        [ngClass]="{ 'is-invalid': submitted && formCtr.simple_date_format.errors }">
                                    <option disabled value="">- select format -</option>
                                    @for (format of formats; track format) {
                                        <option value="{{ format.id }}">
                                            {{ format.name }}
                                        </option>
                                    }
                                </select>
                                <select id="date-separator" class="col-4 form-control" formControlName="separator"
                                        [ngClass]="{ 'is-invalid': submitted && formCtr.separator.errors }">
                                    <option disabled value="">- select separator -</option>
                                    @for (separator of separators; track separator) {
                                        <option value="{{ separator.id }}">
                                            {{ separator.name }}
                                        </option>
                                    }
                                </select>
                                <div class="custom-control custom-checkbox col-8 offset-4 mt-2">
                                    <input type="checkbox" class="custom-control-input" id="four-digit-year"
                                           formControlName="four_digit_year">
                                    <label class="custom-control-label" for="four-digit-year"
                                           style="font-weight: normal;">
                                        Four digit year</label>
                                </div>
                                @if (submitted && (formCtr.simple_date_format.errors || formCtr.separator.errors)) {
                                    <div
                                        class="invalid-feedback offset-4 col-8 px-0">
                                        @if (formCtr.simple_date_format.errors || formCtr.separator.errors) {
                                            <div>The date format is required</div>
                                        }
                                        @if (formCtr.simple_date_format.errors?.server_error) {
                                            <div>
                                                {{ formCtr.simple_date_format.errors.server_error }}
                                            </div>
                                        }
                                        @if (formCtr.separator.errors?.server_error) {
                                            <div>
                                                {{ formCtr.separator.errors.server_error }}
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="row form-group">
                                <label for="teams" class="col-4 col-form-label">Teams:</label>
                                <abq-form-check-dropdown
                                    id="teams" class="form-control col-sm-7" formControlName="teams"
                                    [options]="teamNames"
                                    [ngClass]="{ 'is-invalid': submitted && formCtr.teams.errors }">
                                </abq-form-check-dropdown>
                                @if (submitted && formCtr.teams.errors) {
                                    <div class="invalid-feedback offset-4">
                                        @if (formCtr.teams.errors.server_error) {
                                            <div>
                                                {{ formCtr.teams.errors.server_error }}
                                            </div>
                                        }
                                    </div>
                                }

                            </div>
                            @if (submitted && registerForm.errors) {
                                <div>
                                    @if (registerForm.errors['server_error']) {
                                        <div>
                                            <div class="alert alert-danger" role="alert">
                                                {{ registerForm.errors['server_error'] }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            <div class="row form-group mt-4">
                                <button type="submit" class="btn btn-primary btn-block">
                                    Register
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col text-center">
            <strong>AbaQus Field</strong> - Copyright 2019
        </div>
    </div>
</div>
<abq-message-modal [protected]="'static'"></abq-message-modal>
<abq-spinner-modal></abq-spinner-modal>
